export const markersMixin = {
  data() {
    return {
      markerScale: 1.0,
      canvasWidth: null,
      canvasHeight: null
    }
  },
  props: {
    xMax: {
      type: Number,
      required: true
    },
    xMin: {
      type: Number,
      required: true
    },
    yMax: {
      type: Number,
      required: true
    },
    yMin: {
      type: Number,
      required: true
    }
  },
  methods: {
    markersUpdate(chart, markers) {
      this.clearMarkers(chart)
      this.renderMarkers(chart, markers)
    },
    clearMarkers(chart) {
      let children = [].slice.call(chart.children)
      children.forEach(el => {
        if (el.localName === 'svg') {
          chart.removeChild(el)
        }
      })
    },
    renderMarkers(chart, markers) {
      if (markers == null) return
      let markersInRange = markers.filter(marker => {
        return marker.point[0] >= this.xMin && marker.point[0] <= this.xMax
      })
      if (markersInRange.length === 0) {
        return
      }
      markersInRange.forEach(marker => {
        let x =
          ((marker.point[0] - this.xMin) / (this.xMax - this.xMin)) *
          this.canvasWidth
        let y =
          this.canvasHeight -
          ((marker.point[1] - this.yMin) / (this.yMax - this.yMin)) *
            this.canvasHeight

        let svg = this.svgForMarkerType(
          marker.type,
          marker.shortName,
          marker.isFlipped
        )

        // Add svg and position
        let svgEl = chart.appendChild(svg)
        let markerWidth = svgEl.width.baseVal.value
        let markerHeight = svgEl.height.baseVal.value
        if (marker.isFlipped) {
          svgEl.setAttribute('y', y - markerHeight * 0.08)
          svgEl.setAttribute('x', x - markerWidth / 2.0)
        } else {
          svgEl.setAttribute('y', y - markerHeight * 0.92)
          svgEl.setAttribute('x', x - markerWidth / 2.0)
        }
      })
    },
    svgForMarkerType(type, shortName, isFlipped) {
      let svg
      switch (type) {
        case 'bolus':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getBolusHtml_flip(shortName))
          } else {
            svg = this.createElementFromHTML(this.getBolusHtml(shortName))
          }
          break
        case 'iv_up':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getIvUpHtml_flip(shortName))
          } else {
            svg = this.createElementFromHTML(this.getIvUpHtml(shortName))
          }
          break
        case 'iv_down':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getIvDownHtml_flip(shortName))
          } else {
            svg = this.createElementFromHTML(this.getIvDownHtml(shortName))
          }
          break
        case 'iv_off':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getIvOffHtml_flip(shortName))
          } else {
            svg = this.createElementFromHTML(this.getIvOffHtml(shortName))
          }
          break
        case 'volume':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getVolumeHtml_flip())
          } else {
            svg = this.createElementFromHTML(this.getVolumeHtml())
          }
          break
        case 'square':
          if (isFlipped) {
            svg = this.createElementFromHTML(this.getSquareHtml_flip(shortName))
          } else {
            svg = this.createElementFromHTML(this.getSquareHtml(shortName))
          }
          break
        default:
          svg = this.createElementFromHTML(this.getBolusHtml('N/A'))
      }
      svg.style.position = 'absolute'
      svg.setAttribute('width', 18 * this.markerScale + '%')
      svg.setAttribute('height', 18 * this.markerScale + '%')
      return svg
    },
    createElementFromHTML(htmlString) {
      let div = document.createElement('div')
      div.innerHTML = htmlString.trim()
      return div.firstChild
    },
    getIvUpHtml(shortName) {
      return `
          <svg width="49px" height="56px" viewBox="0 0 49 56" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="IV-Increase-Marker" transform="translate(-1.000000, -1.000000)">
                      <g id="bg">
                          <path d="M25.5,39.5 L25.5,49" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="52.5" r="3.5"></circle>
                          <path d="M26.8081039,3.11510636 C26.7335876,2.99886552 26.6358064,2.89931567 26.52092,2.82272767 C26.0613858,2.51638342 25.4405187,2.64056838 25.1341744,3.10010254 L2.90489372,36.4453147 C2.79538835,36.6095791 2.73695393,36.8025811 2.73695393,37 C2.73695393,37.5522847 3.18466918,38 3.73695393,38 L47.3422313,38 C47.5335479,38 47.7208493,37.9451193 47.8819128,37.8418693 C48.3468644,37.5438114 48.4821585,36.92527 48.1841006,36.4603185 L26.8081039,3.11510636 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#D6B3D3"></path>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="36">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>`
    },
    getIvDownHtml(shortName) {
      return `
          <svg width="48px" height="54px" viewBox="0 0 48 54" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="IV-Increase-Marker" transform="translate(-1.000000, -2.000000)">
                      <g id="bg" transform="translate(0.000000, 2.000000)">
                          <path d="M25.5,36.5 L25.5,46" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="49.5" r="3.5"></circle>
                          <path d="M26.3029291,3.17402445 C26.2262173,3.05196548 26.1240212,2.94793589 26.0033455,2.86906593 C25.5410414,2.56691806 24.9213306,2.69675037 24.6191827,3.1590545 L2.85933347,36.4529129 C2.75302425,36.6155723 2.69640915,36.8056814 2.69640915,37 C2.69640915,37.5522847 3.1441244,38 3.69640915,38 L46.380843,38 C46.5691125,38 46.7535578,37.9468522 46.9129601,37.8466707 C47.3805635,37.5527905 47.5213939,36.9354862 47.2275137,36.4678828 L26.3029291,3.17402445 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#D6B3D3" transform="translate(25.000000, 19.500000) scale(1, -1) translate(-25.000000, -19.500000) "></path>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="15">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>`
    },
    getIvOffHtml(shortName) {
      return `
          <svg width="48px" height="54px" viewBox="0 0 48 54" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="IV-Increase-Marker" transform="translate(-1.000000, -2.000000)">
                      <g id="bg" transform="translate(0.000000, 2.000000)">
                          <path d="M25.5,36.5 L25.5,46" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="49.5" r="3.5"></circle>
                          <path d="M26.3029291,3.17402445 C26.2262173,3.05196548 26.1240212,2.94793589 26.0033455,2.86906593 C25.5410414,2.56691806 24.9213306,2.69675037 24.6191827,3.1590545 L2.85933347,36.4529129 C2.75302425,36.6155723 2.69640915,36.8056814 2.69640915,37 C2.69640915,37.5522847 3.1441244,38 3.69640915,38 L46.380843,38 C46.5691125,38 46.7535578,37.9468522 46.9129601,37.8466707 C47.3805635,37.5527905 47.5213939,36.9354862 47.2275137,36.4678828 L26.3029291,3.17402445 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#D6B3D3" transform="translate(25.000000, 19.500000) scale(1, -1) translate(-25.000000, -19.500000) "></path>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="15">${shortName}</tspan>
                      </text>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="18" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="30" text-anchor="middle">0</tspan>
                      </text>
                  </g>
              </g>
          </svg>`
    },
    getBolusHtml(shortName) {
      return `
        <svg width="51px" height="48px" viewBox="0 0 51 48"  xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Bolus-Marker">
                <g>
                    <g id="bg">
                        <path d="M25.5,29.5 L25.5,40" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                        <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="43.5" r="3.5"></circle>
                        <rect id="Rounded-Rect" stroke="#878787" stroke-width="2" fill="#D6B3D3" x="1" y="1" width="49" height="27" rx="2"></rect>
                    </g>
                    <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                        <tspan x="24.5" y="20">${shortName}</tspan>
                    </text>
                </g>
            </g>
        </g>
        </svg>`
    },
    getSquareHtml(shortName) {
      return `
        <svg width="51px" height="48px" viewBox="0 0 51 48"  xmlns="http://www.w3.org/2000/svg" >
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Square-Marker">
                <g>
                    <g id="bg">
                        <path d="M25.5,29.5 L25.5,40" id="Stem" stroke="#373737" stroke-width="2" stroke-linecap="square"></path>
                        <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#373737" cx="25.5" cy="43.5" r="3.5"></circle>
                        <rect id="Rounded-Rect" stroke="#373737" stroke-width="2" fill="white" x="11" y="1" width="27" height="27" rx="2"></rect>
                    </g>
                    <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                        <tspan x="24.5" y="20">${shortName}</tspan>
                    </text>
                </g>
            </g>
        </g>
        </svg>`
    },
    getVolumeHtml() {
      return `
          <svg width="49px" height="47px" viewBox="0 0 49 47"  xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Volume-Challenge-Marker">
                      <g id="bg">
                          <path d="M24.5,28.5 L24.5,39" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="24.5" cy="42.5" r="3.5"></circle>
                          <path d="M13.9140337,1 C13.6237929,1 13.347871,1.12610095 13.1579243,1.34555473 L1.93043276,14.3171691 C1.5963651,14.7031321 1.60661897,15.2787538 1.95422106,15.6525739 L13.1389921,27.6809595 C13.3281813,27.8844184 13.5934858,28 13.8713132,28 L35.128699,28 C35.4065229,28 35.6718242,27.8844213 35.8610131,27.680967 L47.0457715,15.6528418 C47.3933776,15.279025 47.4036372,14.7034031 47.069573,14.3174366 L35.8420704,1.34556188 C35.6521236,1.1261038 35.376199,1 35.0859549,1 L13.9140337,1 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#FFFFFF"></path>
                      </g>
                      <text id="Vol" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000">
                          <tspan x="13.0625" y="20">Vol</tspan>
                      </text>
                  </g>
              </g>
          </svg>
        `
    },
    getIvUpHtml_flip(shortName) {
      return `
              <svg width="49px" height="56px" viewBox="0 0 49 56" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="IV-Increase-Marker-Copy" transform="translate(-1.000000, 1.000000)">
                      <g id="bg">
                          <path d="M26,7.5 L26,17" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="26" cy="3.5" r="3.5"></circle>
                          <path d="M26.8081039,19.1151064 C26.7335876,18.9988655 26.6358064,18.8993157 26.52092,18.8227277 C26.0613858,18.5163834 25.4405187,18.6405684 25.1341744,19.1001025 L2.90489372,52.4453147 C2.79538835,52.6095791 2.73695393,52.8025811 2.73695393,53 C2.73695393,53.5522847 3.18466918,54 3.73695393,54 L47.3422313,54 C47.5335479,54 47.7208493,53.9451193 47.8819128,53.8418693 C48.3468644,53.5438114 48.4821585,52.92527 48.1841006,52.4603185 L26.8081039,19.1151064 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#D6B3D3"></path>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="52">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>
          `
    },
    getIvDownHtml_flip(shortName) {
      return `
              <svg width="48px" height="57px" viewBox="0 0 48 57" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="IV-Decrease-Marker" transform="translate(-1.000000, 1.000000)">
                      <path d="M25.5,7.5 L25.5,17" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                      <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="3.5" r="3.5"></circle>
                      <path d="M26.3029291,21.1740245 C26.2262173,21.0519655 26.1240212,20.9479359 26.0033455,20.8690659 C25.5410414,20.5669181 24.9213306,20.6967504 24.6191827,21.1590545 L2.85933347,54.4529129 C2.75302425,54.6155723 2.69640915,54.8056814 2.69640915,55 C2.69640915,55.5522847 3.1441244,56 3.69640915,56 L46.380843,56 C46.5691125,56 46.7535578,55.9468522 46.9129601,55.8466707 C47.3805635,55.5527905 47.5213939,54.9354862 47.2275137,54.4678828 L26.3029291,21.1740245 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#D6B3D3" transform="translate(25.000000, 37.500000) scale(1, -1) translate(-25.000000, -37.500000) "></path>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24" y="31">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>
          `
    },
    getBolusHtml_flip(shortName) {
      return `
              <svg width="51px" height="48px" viewBox="0 0 51 48" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Bolus-Marker" transform="translate(0.000000, 2.000000)">
                      <g id="bg">
                          <path d="M25.5,6.5 L25.5,17" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="25.5" cy="2.5" r="3.5"></circle>
                          <rect id="Rounded-Rect" stroke="#878787" stroke-width="2" fill="#D6B3D3" x="1" y="18" width="49" height="27" rx="2"></rect>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="25.5" y="37">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>
        `
    },
    getSquareHtml_flip(shortName) {
      return `
              <svg width="51px" height="48px" viewBox="0 0 51 48" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Bolus-Marker" transform="translate(0.000000, 2.000000)">
                      <g id="bg">
                          <path d="M25.5,6.5 L25.5,17" id="Stem" stroke="#373737" stroke-width="2" stroke-linecap="square"></path>
                          <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#373737" cx="25.5" cy="2.5" r="3.5"></circle>
                          <rect id="Rounded-Rect" stroke="#373737" stroke-width="2" fill="white" x="12" y="18" width="27" height="27" rx="2"></rect>
                      </g>
                      <text id="Marker-Label" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="25.5" y="37">${shortName}</tspan>
                      </text>
                  </g>
              </g>
          </svg>
        `
    },
    getVolumeHtml_flip() {
      return `
              <svg width="49px" height="49px" viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Volume-Marker" transform="translate(0.000000, 1.000000)">
                      <path d="M24.5,7.5 L24.5,18" id="Stem" stroke="#878787" stroke-width="2" stroke-linecap="square"></path>
                      <circle id="Oval" stroke="#FFFFFF" stroke-width="0.5" fill="#878787" cx="24.5" cy="3.5" r="3.5"></circle>
                      <path d="M13.9140337,20 C13.6237929,20 13.347871,20.1261009 13.1579243,20.3455547 L1.93043276,33.3171691 C1.5963651,33.7031321 1.60661897,34.2787538 1.95422106,34.6525739 L13.1389921,46.6809595 C13.3281813,46.8844184 13.5934858,47 13.8713132,47 L35.128699,47 C35.4065229,47 35.6718242,46.8844213 35.8610131,46.680967 L47.0457715,34.6528418 C47.3933776,34.279025 47.4036372,33.7034031 47.069573,33.3174366 L35.8420704,20.3455619 C35.6521236,20.1261038 35.376199,20 35.0859549,20 L13.9140337,20 Z" id="Rectangle" stroke="#808080" stroke-width="2" fill="#FFFFFF"></path>
                      <text id="Vol" font-family="SegoeUI-Bold, Segoe UI" font-size="14" font-weight="bold" fill="#000000" text-anchor="middle">
                          <tspan x="24.5" y="39">Vol</tspan>
                      </text>
                  </g>
              </g>
          </svg>
        `
    }
  }
}
